'use strict';

export default function chartConfig(scope) {
    'ngInject';
    
    let chartConfig = {
        chart: {
            type: 'column',
            height: 400,
            events: {
                load: function() {
                    // Highcharts オブジェクトへの参照をコンパクトに実現するため、arrow function を用いない
                    scope.chart = this.chart;
                }
            }
        },
        // colors: ['#2b908f'],
        title: { text: '1日の電力消費実績' },
        legend: { enabled: false },
        xAxis: {
            categories: scope.categories,
            crosshair: true,
            max: scope.categories.length - 1
        },
        yAxis: {
            labels: {
                format: '{value}'
            },
            title: {
                text: '電力量 [kWh]'
            }
        },
        tooltip: {
            enabled: true,
            shared: true,
            formatter: function(){
                let sum = 0;
                let pointsFormat = '';

                if(scope.isOverStackLimit) {
                    sum = this.points[0].y;
                } else {
                    angular.forEach(this.points, function(point, i) {
                        pointsFormat += '<br/><span style="color:'+ point.series.color +';font-size: 12px">\u25CF</span> <span style="font-size: 13px;"> ';
                        pointsFormat += point.y + " kWh";
                        pointsFormat += `<br/><span style="font-size: 10px;">${ subString(point.series.options.location) }</span>`;
                        pointsFormat += "</span>"
                        sum = scope.MathUtil.add(sum, point.y);
                    });
                }

                let headerFormat = `<tspan style="font-size: 12px">${ this.x }</tspan> <tspan style="font-size: 13px">合計: ${ sum } kWh</tspan>`;

                return headerFormat + pointsFormat;
            }
        },
        plotOptions: { 
            column: {
                grouping: false,
                stacking: 'normal'
            }
        }
    };
    return chartConfig;

    function subString(str, limit=20) {
        if(str.length <= 20){ return str; }
        return str.substr(0, limit) + '...';
    }
}



// WEBPACK FOOTER //
// ./public/dev/app/group_report/daily/daily_group_report.config.js